import React from "react";
import RegisterPage from "../components/RegisterPage";
import { useHSE } from "../lib/store";

const RISK = {
  Low: { bg: "#DCFCE7", color: "#166534" },
  Medium: { bg: "#FEF3C7", color: "#854D0E" },
  High: { bg: "#FFE4E6", color: "#9F1239" },
  Critical: { bg: "#FEE2E2", color: "#7F1D1D" },
};
const STATUS = {
  Open: { bg: "#FEF3C7", color: "#854D0E" },
  "In Progress": { bg: "#DBEAFE", color: "#1E40AF" },
  Closed: { bg: "#DCFCE7", color: "#166534" },
  Overdue: { bg: "#FEE2E2", color: "#7F1D1D" },
};

export default function Inspections() {
  const { data, siteNames } = useHSE();
  const legalRefIds = (data.legalRefs || []).map((l) => l.id);
  const inspectionTypes = data.settings.inspectionTypes || ["Equipment", "PPE", "Workplace", "Fire Safety", "Electrical", "Scaffolding", "Lifting Gear"];

  return (
    <RegisterPage
      title="HSSE Inspections"
      subtitle="Crane, fire pump, PPE, lifting gear, rig, hygiene, pest control and workplace inspection tracking"
      storeKey="inspections"
      idPrefix="INSP"
      columns={[
        { key: "id", label: "Inspection ID" },
        { key: "date", label: "Date" },
        { key: "site", label: "Site" },
        { key: "area", label: "Area" },
        { key: "type", label: "Type" },
        { key: "inspector", label: "Inspector" },
        { key: "obsRefId", label: "Obs / SOR ID", render: (r) => r.obsRefId ? <span className="font-mono text-[11px] text-[#2563EB]">{r.obsRefId}</span> : <span className="text-slate-300">—</span> },
        { key: "findings", label: "Finding" },
        { key: "risk", label: "Risk" },
        { key: "legalRef", label: "Legal Ref", render: (r) => r.legalRef ? <span className="font-mono text-[11px] text-[#082B4D]">{r.legalRef}</span> : <span className="text-slate-300">—</span> },
        { key: "responsible", label: "Responsible" },
        { key: "dueDate", label: "Due" },
        { key: "status", label: "Status" },
        { key: "completionDate", label: "Completed" },
      ]}
      badgeMap={{ risk: RISK, status: STATUS }}
      formFields={[
        { key: "id", label: "Inspection ID" },
        { key: "date", label: "Date", type: "date" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "area", label: "Area" },
        { key: "type", label: "Inspection Type", type: "select", options: inspectionTypes },
        { key: "inspector", label: "Inspector" },
        { key: "obsRefId", label: "Observation ID / SOR ID" },
        { key: "findings", label: "Finding / Description", type: "textarea", full: true },
        { key: "risk", label: "Risk Level", type: "select", options: ["Low", "Medium", "High", "Critical"] },
        { key: "legalRef", label: "Legal Reference", type: "select", options: legalRefIds },
        { key: "correctiveAction", label: "Corrective Action", type: "textarea", full: true },
        { key: "responsible", label: "Responsible Person" },
        { key: "dueDate", label: "Due Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["Open", "In Progress", "Closed", "Overdue"] },
        { key: "completionDate", label: "Completion Date", type: "date" },
        { key: "remarks", label: "Remarks", type: "textarea", full: true },
      ]}
    />
  );
}
